import React, { useRef } from 'react';
import { ModalWraper } from '../UI/styledConstants';
import IconClose from '../../assets/images/IconClose';
//import IconSuccess from '../UI/AnimatedComponent/IconSuccess';
import logoBlack from '../../assets/images/logoBlack.svg';
import backgroundImg from '../../assets/images/bg-img.png';
import { clickOutside, downloadDivAsImage, getCurrentDate, numberToWords, overLayers } from '../../utils/common';
import { isEmpty } from 'lodash';
import successImg from '../../assets/images/successimg.png';
import { useEffect } from 'react';

const AddMoneyReceipt = ({ data={}, setData =() =>{} }) => {
	const handleDownloadClick = (title) => {
		const divElement = document.getElementById('model');
		downloadDivAsImage(divElement, title);
	};


	
		const boxRef = useRef(null);
		useEffect(() =>{
			overLayers(true);
			clickOutside(true,boxRef,() => setData({}));
		
			return(() =>{
				overLayers(false)
				clickOutside(false,boxRef,() => setData({}));
			})
		
		},[]);
	
	return (
		<ModalWraper url={backgroundImg}>
			<div className="modal modal-success" id="model" ref={boxRef}>
				<div className="flex modal-header justify-between">
					<div className="logo">
						<img src={logoBlack} alt={'logo'} />
						<div>
							<p>Invoicing and payments</p>
							<p>powered by Pay2Mobile</p>
						</div>
					</div>

					<div className="buttons">
						<button className="button-solid" style={{ marginRight: '8px' }} onClick={() => handleDownloadClick('Cridit Card receipt')}>
							Download
						</button>
						<button className="button-solid" onClick={() => window.print()}>
							Print
						</button>
					</div>
				</div>
				<div className="modal-close" onClick={() => setData({})}>
					<IconClose />
				</div>
				<div className="text-center modal-title">
					<h2 className="transactionMsg" style={{fontSize:"20px"}}>{data?.status === "SUCCESS"?"Transaction Successful":"Transaction Fail"}</h2>
					<h3 className="amount">₹{data?.amount}</h3>
					<p className="amount-text">{numberToWords(data?.amount)}</p>
				</div>
				<div className="modal-body">
					<div className="txn-daital">
						<div className="flex justify-between txn-daital-h">
							<div>Send To</div>
						</div>
                        {!isEmpty(data?.status) && (
							<div className="flex justify-between txn-desc">
								<div className="txn-desc-right fs-sm-12">
									<div>
										<span className='fs-sm-12'>Status</span>
									</div>
								</div>
								<div className="txn-desc-left fs-sm-12">
									<div>
										<span>
											<div className="detail-desc success fs-sm-12">
                                                {data?.status?.toLowerCase() === "success"?
                                                <><img src={successImg} alt={"success"} />
												{data?.status}</>
                                                :<span style={{color:"red"}}> {data?.status}</span>}
												
											</div>
										</span>
									</div>
								</div>
							</div>
						)}  
						  {!isEmpty(data?.txnType) && (
							<div className="flex justify-between txn-desc">
								<div className="txn-desc-right fs-sm-12">
									<div>
										<span>Transaction Type</span>
									</div>
								</div>
								<div className="txn-desc-left fs-sm-12">
								 <div>
									 <span>{data?.txnType+" (Add Money)"}</span>
								 </div>
							 </div>
							
							</div>
						)}  
						  {!isEmpty(data?.txnId) && (
							<div className="flex justify-between txn-desc">
								<div className="txn-desc-right fs-sm-12">
									<div>
										<span>Transaction Id</span>
									</div>
								</div>
								<div className="txn-desc-left fs-sm-12">
								 <div>
									 <span>{data?.txnId}</span>
								 </div>
							 </div>
							
							</div>
						)}  
						  {!isEmpty(data?.orderId) && (
							<div className="flex justify-between txn-desc">
								<div className="txn-desc-right fs-sm-12">
									<div>
										<span>Order Id</span>
									</div>
								</div>
								<div className="txn-desc-left fs-sm-12">
								 <div>
									 <span>{data?.orderId}</span>
								 </div>
							 </div>
							
							</div>
						)}  
						  {!isEmpty(data?.responseDateTime) && (
							<div className="flex justify-between txn-desc">
								<div className="txn-desc-right fs-sm-12">
									<div>
										<span>Date & Time</span>
									</div>
								</div>
								<div className="txn-desc-left fs-sm-12">
								 <div>
									 <span>{getCurrentDate("",data?.responseDateTime,true)}</span>
								 </div>
							 </div>
							
							</div>
						)}  
						
					</div>
				</div>
			</div>
		</ModalWraper>
	);
};

export default AddMoneyReceipt;
